import React, { useContext, useEffect, useState } from 'react'
import ReactPlayer from 'react-player'

import { Link, useParams } from 'react-router-dom';
import axios from 'axios'
import { faDotCircle } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AnimatedPage from '../AnimatedPage/AnimatedPage';

import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';

import "./checkout.css"
import Navbar_two from '../Navbar/Navbar2';
import Checkout_new from './Checkout_new';

import Image from "./soon3.jpg"
import Navbar from '../Navbar/Navbar';



import { UserDataContext } from '../UserContext/UserContext'




export default function Checkout() {


  let { Base_url } = useContext(UserDataContext)

  const navigate = useNavigate();

  let token = localStorage.getItem("Token")
  const isLogged = !(token === null || token === "undefined" || token === "");
  const [couponTitle, setCouponTitle] = useState("");

  const [couponCode, setCouponCode] = useState("");
  const [discountedPrices, setDiscountedPrices] = useState(null);
  const [hasCoupon, setHasCoupon] = useState(false);


  // course id
  const { id } = useParams();

  const [course_infos, setCourseInfos] = useState({});
  const [discountPrice, setDisountPrice] = useState(null)
  const user_id = parseInt(localStorage.getItem("User_id"))

  const [loading, setLoading] = useState(false);

  const [paidChecking, setPaidChecking] = useState(false);
  const [orderData, setOrderData] = useState({});
  const [fakePrice,setFakePrice]=useState({})
  const [paypalReloadKey, setPaypalReloadKey] = useState(0);

  let [country, setCountry] = useState("")

  // let [price,setPrice]=useState()
  const [price, setPrice] = useState();          // display value, e.g., "99 LE"
  const [numericPrice, setNumericPrice] = useState(); // raw numeric value for backend

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const response = await axios.get(`${Base_url}/courses/${id}`);
        const course_data = await response.data;
        setCourseInfos(course_data);
        setLoading(false);
        localStorage.setItem("CourseInfo", JSON.stringify(course_data));

        setOrderData({
          "course": course_data.id,
          "user": user_id
        });

        // Call CheckPaidorNot after setting course_data
        CheckPaidorNot(course_data.id, user_id);
      } catch (error) {
        toast.warning("OOOPS , Something went wrong");
      }
    }

    async function CheckPaidorNot(course_id, user_id) {
      try {
        const response = await axios.get(`${Base_url}/check_paid_course/${user_id}/${course_id}/`);
        response.data.paid ? setPaidChecking(true) : setPaidChecking(false);
      } catch (error) {
        toast.warning("OOOPS , Something went wrong");
      }
    }


    fetchData();
  }, [id]);

  useEffect(() => {
    async function getIpAddress() {
      try {
        let response = await axios.get("https://get.geojs.io/v1/ip")
        let r1 = response.data;
        // let r1="2001:16a4:17:95c8:85a4:4be4:e3f3:f3d3"
        // let r1="95.181.235.158"
        // let r1="197.54.229.82"
        let responseCountry = await axios.post(`https://get.geojs.io/v1/ip/country/${r1}`)

        //  console.log(responseCountry.data=="SA\n");
        setCountry(responseCountry.data)
        // console.log(responseCountry.data);



      }
      catch {
        setCountry("other")
      }
    }

    getIpAddress()
  }, [country])

  useEffect(() => {
      if (!course_infos) return; // ✅ prevent running before data exists

  async function RateExchange() {
    
    if (hasCoupon) return; // prevent overriding discounted price

    const usdPrice = parseFloat(course_infos.price); // 🟢 السعر بالدولار
    setNumericPrice(usdPrice); // ✅ ثابت بالدولار

    if (country === "EG\n") {
      setPrice(parseInt(course_infos.price_LE) + " LE");
      setFakePrice(
        course_infos.fake_price_LE
          ? parseInt(course_infos.fake_price_LE) + " LE"
          : null
      );
    } else if (country === "SA\n") {
      setPrice(parseInt(course_infos.price_SR) + " SAR");
      setFakePrice(
        course_infos.fake_price_SR
          ? parseInt(course_infos.fake_price_SR) + " SAR"
          : null
      );
    } else {
      setPrice(usdPrice + " $");
      setFakePrice(
        course_infos.fake_price
          ? parseInt(course_infos.fake_price) + " $"
          : null
      );
}

  }

  RateExchange();
}, [course_infos, country, hasCoupon]);



 const applyCoupon = async () => {
  if (!isLogged) {
    toast.warning("You must be logged in to apply a coupon.");
    return;
  }

  try {
    const response = await axios.post(`${Base_url}/apply-coupon/`, {
      course_id: course_infos.id,
      user_id: user_id,
      coupon_title: couponCode
    });

    const discounted = response.data.discounted_prices?.coupon || response.data.discounted_prices;
    const couponTitle = response.data.coupon_title;
    let usdPrice = parseFloat(discounted.cost_USD); // ✅ نستخدم السعر بالدولار هنا

    setCouponTitle(couponTitle);
    setDisountPrice(!isNaN(usdPrice) ? `${usdPrice} $` : "Invalid price");

    const normalizedCountry = country.trim();

    // Show user the localized price
    let displayPrice;
    if (normalizedCountry === "EG") {
      displayPrice = parseFloat(discounted.cost_EGP);
      setPrice(!isNaN(displayPrice) ? `${displayPrice} LE` : "Invalid price");
    } else if (normalizedCountry === "SA") {
      displayPrice = parseFloat(discounted.cost_SAR);
      setPrice(!isNaN(displayPrice) ? `${displayPrice} SAR` : "Invalid price");
    } else {
      displayPrice = usdPrice;
      setPrice(!isNaN(displayPrice) ? `${displayPrice} $` : "Invalid price");
    }

    // ✅ regardless of country, always set numericPrice as USD
    setNumericPrice(usdPrice);

    setHasCoupon(true);
    setPaypalReloadKey(prev => prev + 1);
    toast.success("Coupon applied successfully.");
  } catch (error) {
    toast.error(
      error?.response?.data?.non_field_errors?.[0] ||
      error?.response?.data?.detail ||
      "Invalid coupon."
    );
  }
};





useEffect(() => {
  const timer = setTimeout(() => {
    const container = document.getElementById("paypal-button-container");
    if (container) {
      container.innerHTML = "";
    }

    window.paypal
      .Buttons({
        async createOrder() {
          console.log(discountPrice);
          try {
            const response = await fetch(`${Base_url}/create-payment/`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                cart: [
                  {
                    id: course_infos.id,
                    quantity: 1,
                    value: numericPrice,
                    country: country,
                  },
                ],
              }),
            });

            console.log("Sending to PayPal:", {
              value: numericPrice ?? parseInt(course_infos.price),
              course_id: course_infos.id,
              country: country,
            });
            console.log("FINAL SENT PRICE:", numericPrice);

            const orderData = await response.json();

            if (orderData.id) {
              return orderData.id;
            } else {
              const errorDetail = orderData?.details?.[0];
              const errorMessage = errorDetail
                ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
                : JSON.stringify(orderData);

              throw new Error(errorMessage);
            }
          } catch (error) {
            console.error(error);
            resultMessage(`Could not initiate PayPal Checkout...<br><br>${error}`);
          }
        },
        async onApprove(data, actions) {
          try {
            const response = await fetch(`${Base_url}/orders/${data.orderID}/`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
            });
            const orderData = await response.json();

            const errorDetail = orderData?.details?.[0];

            if (errorDetail?.issue === "INSTRUMENT_DECLINED") {
              return actions.restart();
            } else if (errorDetail) {
              throw new Error(`${errorDetail.description} (${orderData.debug_id})`);
            } else if (!orderData.purchase_units) {
              throw new Error(JSON.stringify(orderData));
            } else {
              const transaction =
                orderData?.purchase_units?.[0]?.payments?.captures?.[0] ||
                orderData?.purchase_units?.[0]?.payments?.authorizations?.[0];
              resultMessage(
                `Transaction ${transaction.status}: ${transaction.id}<br><br>See console for all available details`,
              );
              orderSubmiting(orderData);

              console.log(
                "Capture result",
                orderData,
                JSON.stringify(orderData, null, 2),
              );
            }
          } catch (error) {
            console.error(error);
            toast.warning('Sorry, your transaction could not be processed..');
          }
        },
      })
      .render("#paypal-button-container");

    function resultMessage(message) {
      const container = document.querySelector("#result-message");
      if (container) container.innerHTML = message;
    }
  }, 1000);

  return () => {
    clearTimeout(timer);
  };
}, [country, numericPrice, paypalReloadKey]);


  const orderSubmiting = async ({ id, status, purchase_units }) => {
    setOrderData({});
    try {
      const response = await axios.post(`${Base_url}/orders/`, {
        ...orderData,
        "order_id": parseInt(id),
        "order_status": status,
        "amount": discountPrice ? discountPrice : price,
        // "amount": parseInt(purchase_units[0]['payments']['captures'][0]['amount']['value']),
        "user": user_id,
        "course": course_infos.id
      });

      toast.success('Your Order Success , will Navigate Automatically To Lessons Page ', {
        onClose: () => {
          navigate(`/Course_Lectuers/${course_infos.id}/`);
        }
      });
    } catch (error) {
      console.log("error")
      toast.warning("OOOPS , Some Thing Wrong");
    }

    // Example function to show a result to the user. Your site's UI library can be used instead.


  };



  const parsedLessons = course_infos?.lessons?.map((lesson) => {
    const match = lesson.name.match(/Lec (\d+)/); // Extract the number after "Lec"
    const lectureNumber = match ? parseInt(match[1]) : 0; // Convert the number to integer
    return {
      lesson,
      lectureNumber,
    };
  });
  const sortedLessons = parsedLessons?.sort((a, b) => a.lectureNumber - b.lectureNumber);



  return (
    <div>
      <AnimatedPage>
        <ToastContainer />
        <Navbar_two />

        {course_infos.status == "Soon" ?
          <div className='d-flex container'>
            <img src={Image} width={"100%"} style={{ height: "87.2vh", justifyContent: "center" }} />
          </div>
          :
          <>
            <div className="container">
              {loading ?
                <h3 className='text-center my-5'>Loading .....</h3>
                :
                <div className="checkout-parent">
                  <div className="video-parent col-md-7 col-12">
                    <ReactPlayer width={"100%"} height={"100%"}
                      config={{
                        file: {
                          attributes: {
                            controlsList: 'nodownload' // Prevent downloading the video
                          }
                        }
                      }} url={course_infos.trailer} controls />
                  </div>
                  <div className="payemnt-parent col-md-4 col-12">
                    <div className="course-info p-3">
                      <div className="course-infos-top d-flex justify-content-between">
                        <h5> <span className='fw-bold'>Course</span> : {course_infos.name} </h5>
                        <br></br>
                      </div>
{price && (
  <p className="price-line">
    <h5 className="fw-bold m-0">Price:</h5>
    {fakePrice && <span className="old-price">{fakePrice}</span>}
    <span className="current-price">{price}</span>
  </p>
)}

                      
                      <hr style={{ "width": "50%" }} />
                      <h5> <span className='fw-bold'>Instructor</span> :  {course_infos?.instructor?.name}</h5>
                      <hr style={{ "width": "50%" }} />
                      {paidChecking ? (
                        <Link className='btn btn-primary btn-block' to={`/Course_Lectuers/${course_infos.id}`}>
                          GO TO Course Direct
                        </Link>
                      ) : (
                        isLogged ? (
                          <>
                            {country == "EG\n" ?
                              <div class="alert alert-warning" role="alert">
                                If you are located in Egypt, beacuse what is the Central Egyptian Bank did to block transactions with unlocal currencies.

                                You can transfer your amount using InstaPay to: AhmedHamed.97
                                <br></br>

                                or traditional banking transfer to: (Arab Bank): 5015564522419,
                                <br></br>
                                IBAN: EG460044501500005015564522419
                                <br></br>
                                or Vodafone cash to: 01030454662

                                <br></br>
                                <p className='fw-bold'>Send screenshot for the Transaction to 01140460466</p>

                              </div>
                              : ""}

                            <div id="paypal-button-container"></div>
                            <p id="result-message"></p>
                            <div className="mt-3">
                              <input
                                type="text"
                                placeholder="Enter coupon code"
                                value={couponCode}
                                onChange={(e) => setCouponCode(e.target.value)}
                                className="form-control mb-2"
                              />
                              <button className="btn btn-success w-100" onClick={applyCoupon}>
                                Apply Coupon
                              </button>
                            </div>

                            {couponTitle && (
                              <div className="alert alert-info mt-2">
                                Coupon Applied: <strong>{couponTitle}</strong>
                              </div>
                            )}
                          </>
                        ) : (
                          <button className='btn btn-primary btn-block' onClick={() => navigate("/login")}>
                            Log in to Proceed
                          </button>
                        )
                      )}
                    </div>
                  </div>
                </div>
              }
            </div>
            <hr></hr>
            <div className="container description my-2 py-2">
              <h5 className='fw-bold'>Lessons : </h5>
              <ul>
                {sortedLessons?.map((e) =>
                  <li key={e.id}><FontAwesomeIcon icon={faDotCircle} className='text-muted mx-2'></FontAwesomeIcon> <span >{e.lesson.name}</span> </li>
                )}
              </ul></div>
          </>
        }
        {course_infos.status == "Soon" ? "" :
          <div className='description my-5 container p-2' style={{ maxHeight: "300px", overflowY: "scroll", overflowX: "hidden" }}>
            <h5 className='fw-bold text-center'>Descritption <br></br> </h5>
            <hr></hr>
            <span className="price fw-bold" dir="rtl" >
              {course_infos.description?.split("Module (")?.map((e) => <p>{e}</p>
              )}</span>
          </div>
        }
      </AnimatedPage>
    </div>
  );
}